/* eslint-disable */
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Modal from 'react-bootstrap/Modal'
import { ContentLoader } from '../../_components'
import { translateStatus, store, SimpleFetch } from '../../_helpers'
import { momentumService } from '../../_services'

import './Dcm.scss'

const transformArrayToEndAndText = ( arrayOfString, andText = 'e' ) => {
  if ( !arrayOfString.length ) return ''
  if ( arrayOfString.length === 1 ) return arrayOfString[0]
  const itemsWithComma = arrayOfString.slice( 0, arrayOfString.length - 1 ).join( ', ' )
  const lastItem = arrayOfString[arrayOfString.length - 1 ]
  return `${itemsWithComma} ${andText} ${lastItem}`
}

const getScrollTopOffsetWithSearch = ( node ) => {
  if ( node == null ) return 0

  if ( node.scrollTop ) return node.scrollTop

  return getScrollTopOffsetWithSearch( node.parentNode )
}

const styles = {
  dcmInfoTitle: {
    color: '#484c67',
    fontWeight: 300,
    fontSize: 20,
  },
  dcmPreviewText: {
    color: 'white',
    fontWeight: 300,
    fontSize: 14,
  },
  dcmInfoLabel: {
    color: '#484c67',
    fontWeight: 300,
    fontSize: 16,
  },
  dcmContentCode: {
    color: '#484c67',
    fontWeight: 300,
    fontSize: 14,
    maxHeight: 200
  },
  dcmInfoValue: {
    color: '#484c67',
    fontWeight: 300,
    fontSize: 16,
  },
  dcmScheduleInfo: {
    color: '#484c67',
    fontWeight: 300,
    fontSize: 16,
  }
}

const labels = {
  pageview: 'Visualização de Página',
  contain: 'Contém',
  notcontain: 'Não Contém',
  '==': 'Igual',
  stop_momentum: 'Agendada para',
  beforeend: 'Adicionar ao fim',
  afterbegin: 'Adicionar no início',
  replace: 'Substituir conteúdo existente'
}

const Listing = () => {
  const containerRef = useRef( null )
  const [ scrollTopOffsetBeforeModal, setScrollTopOffsetBeforeModal ] = useState( 0 )
  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState([]);
  const [ domain, setDomain ] = useState(
    store.getState().changeDomainReducer.selectedDomain.domain_uuid
  );
  const [ filterLabels, setFilterLabels ] = useState( {} )
  const [ selectedDcm, setSelectedDcm ] = useState({showModal: false, dcm: {}})
  const [ dcmShowContent, setDcmShowContent ] = useState( null )

  async function listDcms() {
    setLoading(true);

    const { status, data: dcms } = await SimpleFetch(`GET`, {}, {}, `momentum`, `momentum/list/${domain}?type=dcm`);
    if ( status !== 200 ) return void 0

    const ordernedDcms = Array.from( dcms ).sort( ( dcmA, dcmB ) => {
      const createdAtA = new Date( dcmA.created_at )
      const createdAtB = new Date( dcmB.created_at )
      if ( createdAtA > createdAtB ) return -1
      if ( createdAtB > createdAtA ) return 1
      return 0
    } )

    setData( ordernedDcms );
    setLoading( false );
  }

  useEffect(() => {
    listDcms()
  }, []);

  const handleDataVisualization = ({target}) => {
    setScrollTopOffsetBeforeModal(
      getScrollTopOffsetWithSearch( containerRef.current )
    )

    const uuid = target.getAttribute('data-uuid')
    const dcmMatch = data.map(d => uuid === d.uuid ? d : null)
    const dcm = dcmMatch.filter(el => el != null)

    setSelectedDcm({showModal: true, dcm: dcm[0]})
  }

  const handleChange = async (data, status) => {
    await momentumService.updateMomentumStatus(data, status, true)
    listDcms()
  }

  const selectedDcmTypes = useMemo( () => {
    return selectedDcm.dcm?.momentums?.reduce( ( selectedDcmTypes, momentum ) => {
      if ( !selectedDcmTypes[momentum.type] ) selectedDcmTypes[momentum.type] = []
      selectedDcmTypes[momentum.type].push( ...momentum.values )
      return selectedDcmTypes
    }, {} )
  }, [ selectedDcm ] )

  useEffect( () => {
    ( async () => {
      const { data: filters } = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/filter/${domain}`)
      const labels = filters.reduce( ( labels, filter ) => {
        labels[filter.key] = filter.name
        return labels
      }, {} )
      setFilterLabels( labels )
    } )()
  }, [ domain ] )

  const handleHideModal = useCallback( () => {
    setSelectedDcm( { showModal: false, dcm: {} } )
    setDcmShowContent( null )
  } )

  return (
    <>
      <section ref={containerRef} className="component component-dcm-listing">
        <div className="component-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <h1 className="title">GCD (Gerenciador de Conteúdo Dinâmico)</h1>
              </div>
              <div className="col-3">
                <Link to={'/dcm/manager'} className="btn btn-white btn-add-momentum float-right">
                  <i className="linearicons-plus-circle"></i>
                  Adicionar GCD
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="component-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Título</th>
                        <th>Status</th>
                        <th>Data de Agendamento</th>
                        <th>Criado em</th>
                        <th>Atualizado em</th>
                        <th>Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        !loading && data ?
                          data.map((momentum, index) => {
                            return <tr key={momentum.uuid}>
                              <td>{index}</td>
                              <td>{momentum.momentum_title}</td>
                              <td>{translateStatus[momentum.status]}</td>
                              <td>{
                                momentum.scheduled_at ? 
                                  moment( momentum.scheduled_at ).add( { hour: 3 } ).format('DD/MM/YYYY - HH:mm')
                                : 'Imediato'
                              }</td>
                              <td>{moment( momentum.created_at ).format('DD/MM/YYYY - HH:mm')}</td>
                              <td>{moment( momentum.updated_at ).format('DD/MM/YYYY - HH:mm')}</td>
                              <td>
                                <div className='flex'>
                                  <button type="button" className="btn btn-xsmall btn-icon btn-white-outlined" title="Visualizar" data-uuid={momentum.uuid} onClick={handleDataVisualization}>
                                    <i className="linearicons-eye"></i>
                                  </button>

                                  {
                                    momentum.status === "Active" ?
                                      <button type="button" className="btn btn-xsmall btn-icon btn-orange" title="Pausar" data-uuid={momentum.uuid} style={{marginLeft: "8px"}} onClick={() => handleChange(JSON.stringify(momentum), "pause")}>
                                        <i className="linearicons-pause-circle"></i>
                                      </button>
                                    : null
                                  }

                                  {
                                    momentum.status === "Paused" ?
                                      <button type="button" className="btn btn-xsmall btn-icon btn-green" title="Pausar" data-uuid={momentum.uuid} style={{marginLeft: "8px"}} onClick={() => handleChange(JSON.stringify(momentum), "start")}>
                                        <i className="linearicons-play-circle"></i>
                                      </button>
                                    : null
                                  }
                                </div>
                              </td>
                            </tr>
                          })
                        : <tr>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                            <td><ContentLoader /></td>
                          </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {
        selectedDcm.dcm && selectedDcm.dcm.length !== 0 ?
          <Modal
            className="modal modal-sidebar-script"
            size="lg"
            centered
            keyboard={false}
            show={selectedDcm.showModal}
            onHide={handleHideModal}
          >
            <Modal.Body>
              <div className="flex border-bottom py-3">
                <span style={ { ...styles.dcmInfoTitle, display: 'block' } }>
                  Título: {selectedDcm.dcm.momentum_title}
                </span>
              </div>
              { !!selectedDcm.dcm?.worktime && (
                <div className="flex border-bottom py-3">
                  <div className="w-full fxg-1">
                    <span style={styles.dcmInfoTitle}>Cronograma:</span>
                    <div style={styles.dcmInfoValue}>
                      { transformArrayToEndAndText(
                        [ 'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado' ]
                          .filter( ( weekDayLabel, weekDayValue ) => selectedDcm.dcm.worktime.weekdays.includes( weekDayValue ) )
                      ) }
                      { ' ' }
                      às {selectedDcm.dcm.worktime.start_at} até {selectedDcm.dcm.worktime.stop_at}
                    </div>
                  </div>

                  <hr />
                </div>
              ) }
              { !!selectedDcm.dcm.scheduled_at && (
                <div className="flex border-bottom py-3">
                  <span style={ { ...styles.dcmScheduleInfo, display: 'block' } }>
                    Agendado para: {moment( selectedDcm.dcm.scheduled_at ).add( { hour: 3 } ).format( 'LLL' )}
                  </span>
                </div>
              ) }
              { !!selectedDcmTypes?.filter?.length && (
                <div className="flex border-bottom py-3">
                  <div className="w-full fxg-1">
                    <span style={styles.dcmInfoTitle}>Filtro:</span>
                    <div>
                      { selectedDcmTypes.filter.map( ( filter, index, filters ) => {
                        const isLast = filters.length === index + 1
                        const className = isLast ? 'row no-gutters py-2' : 'row border-bottom no-gutters py-2'
                        return <div className={className} key={`filter.${index}`}>
                          <div className='col-4'>
                            <span style={styles.dcmInfoLabel}>{filterLabels[filter.filter] ?? filter.filter}</span>
                          </div>
                          <div className='col-2'>
                            <span style={styles.dcmInfoLabel}>{labels[filter.comparation] ?? filter.comparation }</span>
                          </div>
                          <div className='col flex flex-wrap'>
                            {Array.isArray( filter.value )
                              ? filter.value.map( value => <div style={styles.dcmInfoValue} className='mx-2'>{value}</div> )
                              : filter.value}
                          </div>
                        </div>
                      } ) }
                    </div>
                  </div>

                  <hr />
                </div>
              ) }
              { !!selectedDcmTypes?.trigger?.length && (
                <div className="flex border-bottom py-3">
                  <div className="w-full fxg-1">
                    <span style={styles.dcmInfoTitle}>Gatilho</span>
                    <div>
                      { selectedDcmTypes.trigger.map( ( trigger, index, triggers ) => {
                        const isLast = triggers.length === index + 1
                        const className = isLast ? 'row no-gutters py-2' : 'row border-bottom no-gutters py-2'
                        return <div className={className} key={`trigger.${index}`}>
                          <div className='col-4'>
                            <span style={styles.dcmInfoLabel}>{labels[trigger.filter] ?? trigger.filter}</span>
                          </div>
                          <div className='col-2'>
                            <span style={styles.dcmInfoLabel}>{labels[trigger.comparation] ?? trigger.comparation }</span>
                          </div>
                          <div className='col flex flex-wrap'>
                            {trigger.value.map( value => (
                              <div style={styles.dcmInfoValue} className='mx-2'>{value}</div>
                            ) )}
                          </div>
                        </div>
                      } ) }
                    </div>
                  </div>
                </div>
              ) }
              { selectedDcmTypes?.finish?.length === 1 && (
                <div className="flex border-bottom py-3">
                  <div className="w-full fxg-1">
                    <span style={styles.dcmInfoTitle}>Finalização:</span>
                    <div>
                      <div className='row no-gutters py-2'>
                        <div className='col'>
                          <span style={styles.dcmInfoLabel}>{labels[selectedDcmTypes.finish[0].filter] ?? selectedDcmTypes.finish[0].filter}</span>
                        </div>
                        <div className='col flex flex-wrap'>
                          <span style={styles.dcmInfoValue}>{moment( selectedDcmTypes.finish[0].value ).add( { hour: 3 } ).format( 'LLL' )}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) }
              { selectedDcmTypes?.dispatcher?.length === 1 && (
                <div className="flex border-bottom py-3">
                  <div className="w-full fxg-1">
                    <span style={styles.dcmInfoTitle}>Tags customizadas:</span>
                    <div className='mt-2'>
                      <button
                        className='btn btn-xsmall btn-icon btn-green'
                        onClick={ () => {
                          const { customHtml, customCss, customJs } = selectedDcmTypes.dispatcher[0]
                          setDcmShowContent( { customHtml, customCss, customJs } )
                        } }
                      >Pré-visualização</button>
                    </div>
                    <div className='py-2'>
                      { !!selectedDcmTypes.dispatcher[0].htmlElement && (
                        <span style={ { display: 'block' } }>
                          <span style={styles.dcmInfoLabel}>Inserida no elemento:</span>
                          {' '}
                          <span style={styles.dcmInfoValue}>{selectedDcmTypes.dispatcher[0].htmlElement}</span>
                        </span>
                      ) }
                      { !!selectedDcmTypes.dispatcher[0].tagBehavior && (
                        <span style={ { display: 'block' } }>
                          <span style={styles.dcmInfoLabel}>Comportamento:</span>
                          {' '}
                          <span style={styles.dcmInfoValue}>
                            {labels[selectedDcmTypes.dispatcher[0].tagBehavior] ?? selectedDcmTypes.dispatcher[0].tagBehavior}
                          </span>
                        </span>
                      ) }
                      { !!selectedDcmTypes.dispatcher[0].containHtmlElement && (
                        <span style={ { display: 'block' } }>
                          <span style={styles.dcmInfoLabel}>A página deve conter o elemento:</span>
                          {' '}
                          <span style={styles.dcmInfoValue}>
                            {selectedDcmTypes.dispatcher[0].containHtmlElement}
                          </span>
                        </span>
                      ) }
                      { !!selectedDcmTypes.dispatcher[0].containText && (
                        <span style={ { display: 'block' } }>
                          <span style={styles.dcmInfoLabel}>O elemento deve conter o texto:</span>
                          {' '}
                          <span style={styles.dcmInfoValue}>
                            {selectedDcmTypes.dispatcher[0].containText}
                          </span>
                        </span>
                      ) }
                    </div>
                    <div className='row py-2'>
                      <div className="col-4 border-bottom">
                        <span style={styles.dcmInfoLabel}>HTML:</span>
                        <div className='mt-2 overflow-auto w-100' style={ styles.dcmContentCode }>
                          {selectedDcmTypes.dispatcher[0].customHtml}
                        </div>
                      </div>
                      <div className="col-4 border-bottom">
                        <span style={styles.dcmInfoLabel}>CSS:</span>
                        <div className='mt-2 overflow-auto w-100' style={ styles.dcmContentCode }>
                          {selectedDcmTypes.dispatcher[0].customCss}
                        </div>
                      </div>
                      <div className="col-4 border-bottom">
                        <span style={styles.dcmInfoLabel}>JS:</span>
                        <div className='mt-2 overflow-auto w-100' style={ styles.dcmContentCode }>
                          {selectedDcmTypes.dispatcher[0].customJs}
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />
                </div>
              ) }
            </Modal.Body>
          </Modal>
        : null
      }
      {
        dcmShowContent && <DcmPreview {...dcmShowContent}
          scrollTopOffsetBeforeModal={scrollTopOffsetBeforeModal}
          onCloseRequest={ setDcmShowContent.bind( null, null ) }
        />
      }
    </>
  )
}

const DcmPreview = ( {
  customHtml,
  customCss,
  customJs,
  onCloseRequest,
  scrollTopOffsetBeforeModal = 0
} ) => {
  const ref = useRef( null )
  const __html = useMemo( () => `
    <style>${customCss}</style>
    ${customHtml}
  `, [ customHtml, customCss ] )

  const dangerouslySetInnerHTML = useMemo( () => ( { __html } ), [ __html ] )

  useEffect( () => {
    console.log( { customHtml, customCss, customJs } )
  }, [ customHtml, customCss, customJs ] )

  const handleClickWrapper = useCallback( () => {
    onCloseRequest?.()
  }, [ onCloseRequest ] )

  useEffect( () => {
    const handlerKeyUp = event => {
      if ( event.key === 'Escape' ) {
        event.stopPropagation()
        event.preventDefault()
        onCloseRequest?.()
      }
    }

    document.body.addEventListener( 'keyup', handlerKeyUp )

    return () => document.body.removeEventListener( 'keyup', handlerKeyUp )
  }, [ onCloseRequest ] )

  useEffect( () => {
    if ( !ref.current ) return void 0
    const child = ref.current.querySelector( ':not( style ):not( script )' )
    if ( !child ) return void 0
    child.style.display = 'flex'
  }, [] )

  return (
    <div
      onClick={handleClickWrapper}
      style={ {
        position: 'absolute',
        zIndex: 999999,
        backgroundColor: '#00000060',
        top: scrollTopOffsetBeforeModal,
        left: 0,
        bottom: 0,
        right: 0,
        height: '100vh'
      } }
      onClick={handleClickWrapper}
    >
      <div ref={ref} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
      <div style={ {
        position: 'absolute',
        zIndex: 99999999,
        backgroundColor: '#00000060',
        color: 'white',
        top: 0,
        left: 0,
        right: 0,
        padding: '5px 20px'
      } }>
        <div style={styles.dcmPreviewText}>
          Pré-visualização em etapa de testes, talvez o conteúdo não seja mostrado como deveria, qualquer defeito favor reporta a equipe de desenvolvimento.
          <br />
          Por questões de segurança o JavaScript do GCD não é carregado.
          <br />
          Para sair da pré-visualização pressione Esc ou <span style={ {
            cursor: 'pointer',
            textDecoration: 'underline'
          } } onClick={handleClickWrapper}>clique aqui</span>.
        </div>
      </div>
    </div>
  )
}

export { Listing as DcmListingContainer }